import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Box, Typography, useTheme, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

import "swiper/css";
import CoachCard from "../../../../../Components/CoachCard";

export default function CoachSlider({ coachesData }) {
  const theme = useTheme();
  const swiperRef = useRef(null);
  const trainersData = coachesData;

  const handlePrev = () => swiperRef.current?.slidePrev();
  const handleNext = () => swiperRef.current?.slideNext();

  const items = trainersData?.map((trainer) => (
    <SwiperSlide key={trainer._id}>
      <CoachCard trainer={trainer} />
    </SwiperSlide>
  ));
  return (
    <Box sx={{ position: "relative", px: { xs: 0, md: 2 }, py: 4 }}>
      {/* Navigation Buttons */}
      <IconButton
        aria-label="slider prev slide button"
        onClick={handlePrev}
        sx={{
          position: "absolute",
          left: { xs: 0, md: -40 },
          top: "45%",
          transform: "translateY(-50%)",
          zIndex: 10,
          bgcolor: "rgba(30, 30, 30, 0.9)",
          backdropFilter: "blur(8px)",
          color: theme.palette.primary.main,
          width: 44,
          height: 44,
          border: `1px solid ${theme.palette.primary.main}4D`,
          transition: "all 0.3s ease",
          "&:hover": {
            bgcolor: theme.palette.primary.main,
            color: "white",
          },
          display: { xs: "none", md: "inline-flex" },
        }}
      >
        <ChevronLeft sx={{ fontSize: 28 }} />
      </IconButton>

      <IconButton
        aria-label="slider next slide button"
        onClick={handleNext}
        sx={{
          position: "absolute",
          right: { xs: 0, md: -40 },
          top: "45%",
          transform: "translateY(-50%)",
          zIndex: 10,
          bgcolor: "rgba(30, 30, 30, 0.9)",
          backdropFilter: "blur(8px)",
          color: theme.palette.primary.main,
          width: 44,
          height: 44,
          border: `1px solid ${theme.palette.primary.main}4D`,
          transition: "all 0.3s ease",
          "&:hover": {
            bgcolor: theme.palette.primary.main,
            color: "white",
          },
          display: { xs: "none", md: "inline-flex" },
        }}
      >
        <ChevronRight sx={{ fontSize: 28 }} />
      </IconButton>

      {/* Swiper */}
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        modules={[Navigation, Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          640: { slidesPerView: 1.2, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 24 },
          1024: { slidesPerView: 2.5, spaceBetween: 28 },
          1280: { slidesPerView: 3, spaceBetween: 28 },
          // 1600: { slidesPerView: 4, spaceBetween: 32 },
        }}
        style={{ padding: "10px 5px 30px 5px" }}
      >
        {items}
      </Swiper>
    </Box>
  );
}
